import subforms from "./questions.json";

export default (qid, normalize) => {
  // console.log("beauty.js - :", normalize);

  const answer1 = "answer" in normalize ? normalize.answer[0] : {};
  const answer2 = "answer" in normalize ? normalize.answer[1] : {};
  const answer3 = "answer" in normalize ? normalize.answer[2] : {};
  const answer4 = "answer" in normalize ? normalize.answer[3] : {};
  const answer5 = "answer" in normalize ? normalize.answer[4] : {};

  if (subforms[qid].tipe === "radio") {
    return {
      jawaban: normalize.Jawab_Pilih,
      kondisi: normalize.Jawaban_H1,
      jawaban_lainnya: normalize.Lainnya,
    };
  } else if (subforms[qid].tipe === "number") {
    return {
      jawaban:
        "Jawaban_H1" in normalize
          ? String(normalize.Jawaban_H1) == "null"
            ? ""
            : normalize.Jawaban_H1.toString()
          : "",
      jawaban_lainnya: normalize.Lainnya,
    };
  } else if (subforms[qid].tipe === "number_06") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_10") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_14") {
    // console.log("normalize dari beauty>>>", normalize);

    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_15") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_16") {
    // console.log("beauty.js - number_16 processing:");
    // console.log("qid:", qid);
    // console.log("normalize:", normalize);
    // console.log("answer1:", answer1);
    // console.log("answer2:", answer2);
    // console.log("answer3:", answer3);
    // console.log("answer4:", answer4);

    const result = {
      jawabanA: answer1?.pilihanpk || "",
      jawabanB: answer2?.pilihanpk || "",
      jawabanC: answer3?.pilihanpk || "",
      jawabanD: answer4?.pilihanpk || "",
    };

    // console.log("beauty.js - number_16 result:", result);
    return result;
  } else if (subforms[qid].tipe === "number_17") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_18") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_19") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
      jawabanB: normalize.Jawab_Pilih3,
    };
  } else if (subforms[qid].tipe === "number_20") {
    return {
      jawaban: normalize.Jawab_Pilih,
      jawabanA: normalize.Jawab_Pilih2,
    };
  } else if (subforms[qid].tipe === "number_21") {
    // console.log("beauty.js - number_21 processing:", normalize.Jawab_Pilih);

    if (
      ["1", "2", "3", "9", "10", "11", "12"].includes(normalize.Jawab_Pilih)
    ) {
      return {
        jawaban: normalize.Jawab_Pilih,
        jawabanA: "",
      };
    } else if (
      ["4", "5", "6", "7", "8"].includes(normalize.Jawab_Pilih) &&
      normalize.Jawab_Pilih2 !== "1" &&
      normalize.Jawab_Pilih2 !== "2" &&
      normalize.Jawab_Pilih2 !== ""
    ) {
      return {
        jawaban: normalize.Jawab_Pilih,
        jawabanA: "",
      };
    } else {
      return {
        jawaban: normalize.Jawab_Pilih,
        jawabanA: normalize.Jawab_Pilih2,
      };
    }
  } else if (subforms[qid].tipe === "number_26") {
    return {
      jawaban:
        "Jawaban_H1" in normalize
          ? String(normalize.Jawaban_H1) == "null"
            ? ""
            : normalize.Jawaban_H1.toString()
          : "",
      jawaban_lainnya: normalize.Lainnya,
    };
  } else if (subforms[qid].tipe === "checkbox") {
    // console.log("dari beauty>>>", normalize);

    return {
      jawaban: normalize.Jawab_Pilih,
      kondisi: normalize.Jawaban_H1,
      jawaban_lainnya: normalize.Lainnya,
    };
  } else if (subforms[qid].tipe === "checkbox3") {
    return {
      jawaban: normalize.Jawab_Pilih,
      kondisi: normalize.Jawaban_H1,
      jawaban_lainnya: normalize.Lainnya,
    };
  } else if (subforms[qid].tipe === "checkbox2") {
    // if (subforms["0229"].options === "2") {
    //     return {}
    // } else {
    return {
      jawaban: normalize.Jawab_Pilih,
      kondisi: normalize.Jawaban_H1,
      jawaban_lainnya: normalize.Lainnya,
    };
    // }
  } else if (subforms[qid].tipe === "subformradio") {
    // const answer1 = normalize.answer[0];
    // const answer2 = normalize.answer[1];
    // const answer3 = normalize.answer[2];
    // const answer4 = normalize.answer[3];
    // const answer5 = normalize.answer[4];

    return {
      jawabanA: answer1?.pilihanpk || "",
      jawabanB: answer2?.pilihanpk || "",
      jawabanC: answer3?.pilihanpk || "",
      jawabanD: answer4?.pilihanpk || "",
      jawabanE: answer5?.pilihanpk || "",
    };
  } else if (subforms[qid].tipe === "subformradio_18") {
    // const answer1 = normalize.answer[0];
    // const answer2 = normalize.answer[1];
    // const answer3 = normalize.answer[2];
    // const answer4 = normalize.answer[3];
    // const answer5 = normalize.answer[4];

    return {
      jawabanA: answer1?.pilihanpk || "",
      jawabanB: answer2?.pilihanpk || "",
      jawabanC: answer3?.pilihanpk || "",
      jawabanD: answer4?.pilihanpk || "",
      jawabanE: answer5?.pilihanpk || "",
    };
  }

  return {};
};
